import { render, staticRenderFns } from "./ViewAwardees.vue?vue&type=template&id=6dc8e158&"
import script from "./ViewAwardees.vue?vue&type=script&lang=js&"
export * from "./ViewAwardees.vue?vue&type=script&lang=js&"
import style0 from "./ViewAwardees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewAwardees.vue"
export default component.exports